import { z } from 'zod';
import { jobSchema } from './job.js';
/**
 * Événements du moteur de jobs diffusés en temps réel (SSE, XPHOTO-17).
 *
 * Un seul type d'événement au format enveloppe `{ kind, job }` :
 * - `progress` : une progression a été persistée (`done`/`total`/`etaSeconds`).
 * - `finished` : le job a atteint un état terminal (`done`/`failed`/`canceled`)
 *   → sert de notification de fin de job.
 *
 * Le payload transporte le DTO `Job` complet (source unique `jobSchema`), afin
 * que la SPA puisse mettre à jour l'affichage sans requête supplémentaire.
 */
export const jobEventKindSchema = z.enum(['progress', 'finished']);
export const jobEventSchema = z.object({
    kind: jobEventKindSchema,
    job: jobSchema,
});
/**
 * DTO de la liste de jobs (`GET /api/jobs`) : enveloppe simple, extensible
 * (pagination ultérieure) sans casser le contrat.
 */
export const jobListSchema = z.object({
    jobs: z.array(jobSchema),
});
//# sourceMappingURL=job-event.js.map